import React from "react";
import type { LinkProps } from "./LinkProps";
import classes from "./Link.module.scss";
import { clsx } from "clsx";

export const Link: React.FC<LinkProps> = (props) => {
  const { href, className, children, isExternal, ...rest } = props;

  const rel = isExternal ? "noopener noreferrer" : undefined;
  const target = isExternal ? "_blank" : undefined;

  return (
    <a
      href={href}
      className={clsx(classes.link, className)}
      rel={rel}
      target={target}
      {...rest}
    >
      {children}
    </a>
  );
};
